import { lazy } from 'react';

const Warehouses = lazy(() => import('./Warehouses'));
const Products = lazy(() => import('./Products'));
const InboundManage = lazy(() => import('./InboundManage'));
const OutboundManage = lazy(() => import('./OutboundManage'));
const Inventory = lazy(() => import('./Inventory'));
const Statistics = lazy(() => import('./Statistics'));

export const materialsPageRoutes = [
  { path: '/materials/warehouses', component: Warehouses },
  { path: '/materials/products', component: Products },
  { path: '/materials/inbound', component: InboundManage },
  { path: '/materials/outbound', component: OutboundManage },
  { path: '/materials/inventory', component: Inventory },
  { path: '/materials/statistics', component: Statistics }
];
